var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cleave',{staticClass:"form-control",attrs:{"raw":false,"options":_vm.options.number,"placeholder":_vm.placeholder},on:{"blur":_vm.saveCost},model:{value:(_vm.own_price),callback:function ($$v) {_vm.own_price=$$v},expression:"own_price"}})}
var staticRenderFns = []

export { render, staticRenderFns }